import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { HomeExpiredOther } from './components/HomeExpiredOther';
import { HomeExpiredTarget } from './components/HomeExpiredTarget';
import { BrandHyperlink } from '../components/button/brand/BrandHyperlink';

type Props = {
  isIcp: boolean;
  isContacted: boolean;
  hasCalled: boolean;
  onCall: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  onContact: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
};

export const HomeExpiredMain: FC<Props> = ({
  isIcp,
  onContact,
  isContacted,
  hasCalled,
  onCall,
}) => (
  <div className="banner-customers">
    <div className="banner-customers__block">
      <div className="banner-customers__interview__header">
        <h2 className="banner-customers__title">
          <FormattedMessage id="home-expired/HomeExpiredMain.tsx/1" />
        </h2>
        <p className="banner-customers__subtitle">
          <FormattedMessage id="home-expired/HomeExpiredMain.tsx/2" />
        </p>
        <div>
          <BrandHyperlink large href="/tarifs" source="trial_expired">
            <FormattedMessage id="home-expired/HomeExpiredMain.tsx/3" />
          </BrandHyperlink>
          <br />
          {isIcp ? (
            <div className="banner-customers__footer">
              <HomeExpiredTarget
                onCall={onCall}
                isContacted={isContacted}
                hasCalled={hasCalled}
              />
            </div>
          ) : (
            <HomeExpiredOther onClick={onContact} />
          )}
        </div>
      </div>
    </div>
  </div>
);
